import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface mtdSalesDataInterface {
  Gross_Units:number;
  Gross_Dollars:number;
  Returns_Units:number;
  Returns_Dollars:number;
  Net_Units:number;
  Net_Dollars:number;
  Sell_Through_MTD:number;
}

interface TitleListMTDState {
  data: mtdSalesDataInterface;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
}
const initialState: TitleListMTDState = {
  data: {
    Gross_Units:0,
    Gross_Dollars:0,
    Returns_Units:0,
    Returns_Dollars:0,
    Net_Units:0,
    Net_Dollars:0,
    Sell_Through_MTD:0,
  },
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchTitleListMTDSalesRecord = createAsyncThunk(
  "FetchTitleListMTDSalesRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.MTDTITLESALESDATA,data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListMTDSlice = createSlice({
  name: "TitleListMTDData",
  initialState,
  reducers: {
     clearMTDData: (state) => {
      state.data = initialState.data;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListMTDSalesRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListMTDSalesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data.totals;
      })
      .addCase(FetchTitleListMTDSalesRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const {clearMTDData
} = TitleListMTDSlice.actions;
export default TitleListMTDSlice.reducer;
